import React from 'react';
import { string } from 'prop-types';
import I18n from 'i18n-js';
import { Tooltip } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

const parseDomain = (url) => {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
};

const faviconUrl = (domain) => `https://www.google.com/s2/favicons?sz=32&domain=${domain}`;

const TicketContextInfo = ({ url }) => {
  const domain = parseDomain(url);
  if (!domain) return null;

  return (
    <div className="ticket-context-info">
      <div className="ticket-context-info__label">
        {I18n.t('tickets.form.created_from')}
      </div>
      <Tooltip title={url} placement="bottom">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="ticket-context-info__link"
        >
          <img
            className="ticket-context-info__favicon"
            src={faviconUrl(domain)}
            alt=""
          />
          <span className="ticket-context-info__domain">{domain}</span>
          <LinkOutlined className="ticket-context-info__open-icon" />
        </a>
      </Tooltip>
    </div>
  );
};

TicketContextInfo.propTypes = {
  url: string.isRequired,
};

export default TicketContextInfo;
